export default __webpack_public_path__ + "static/media/xpo.24953f40.svg";